import BoxApp from '@derolfgroep/ui-components/src/components/BoxApp/BoxApp'
import AppContent from '../AppContent/AppContent'
import BoxAppLoader from '@derolfgroep/ui-components/src/components/BoxAppLoader/BoxAppLoader'
import useCurrentUser from '../../api/queries/currentUser/useCurrentUser'
import { useCurrentUserInstitutions } from '../../api/queries/currentUser/useCurrentUserInstitutions'
import useToggleLeftDrawer from './useToggleLeftDrawer'
import React, { useMemo, useState } from 'react'
import useCurrentUserProfileSettingSelector from '../../api/selectors/useCurrentUserProfileSettingSelector'
import { SETTING_BACKGROUND_COLOR } from '../../constants'
import { getLocalStorage, setLocalStorage } from '@derolfgroep/utils/lib/misc/localStorage'
import useCurrentUserIdSelector from '../../api/selectors/useCurrentUserIdSelector'
import ZuluConnectAnimation from '../ZuluConnectAnimation/ZuluConnectAnimation'
import RemoteViewProvider from '../../remoteView/v2/RemoteViewProvider'

const AppLayout = () => {
  const currentUserId = useCurrentUserIdSelector()
  const { isLoading: userIsLoading } = useCurrentUser()
  const { isLoading: institutionsIsLoading } = useCurrentUserInstitutions()
  const profileSettingBackgroundColor = useCurrentUserProfileSettingSelector(SETTING_BACKGROUND_COLOR)
  const backgroundColor = useMemo(() => {
    const color = profileSettingBackgroundColor || getLocalStorage(`zc#.${currentUserId}.backgroundColor`)
    setLocalStorage(`zc#.${currentUserId}.backgroundColor`, color)
    return color
  }, [currentUserId, profileSettingBackgroundColor])

  const { isOpen } = useToggleLeftDrawer()

  const [extensionIsInstalled, setExtensionIsInstalled] = useState(false)

  const handleExtensionInstalled = () => {
    // eslint-disable-next-line no-console
    console.info('Extension is installed')
    setExtensionIsInstalled(true)
  }

  React.useEffect(() => {
    document.body.addEventListener('extensionLoaded', handleExtensionInstalled)

    return () => {
      document.body.removeEventListener('extensionLoaded', handleExtensionInstalled)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return userIsLoading || institutionsIsLoading ? (
    <BoxAppLoader
      media={<ZuluConnectAnimation />}
      text="De Portal wordt geladen"
      progressTitle="Bezig met laden"
      backgroundColor={backgroundColor}
    />
  ) : (
    <RemoteViewProvider extensionIsInstalled={extensionIsInstalled}>
      <BoxApp leftDrawerIsOpen={isOpen} backgroundColor={backgroundColor}>
        <AppContent />
      </BoxApp>
    </RemoteViewProvider>
  )
}

export default AppLayout
